export const SET_ID_SELECTED_ACTION = "SET_ID_SELECTED";
export const SET_DEPARTMENTS_ACTION = "SET_DEPARTMENTS";
export const SET_DATE_SELECTED_ACTION = "SET_DATE_SELECTED";
export const SET_TYPE_SELECTED_ACTION = "SET_TYPE_SELECTED";
export const SET_DEPARTMENT_SELECTED_ACTION = "SET_DEPARTMENT_SELECTED";
export const SET_UNIVERSITY_SELECTED_ACTION = "SET_UNIVERSITY_SELECTED_ACTION";
export const SET_ERASMUS_CODE_SELECTED_ACTION = "SET_ERASMUS_CODE_SELECTED_ACTION";
export const SET_COUNTRY_SELECTED_ACTION = "SET_COUNTRY_SELECTED_ACTION";
export const SET_DEPARTMENTAL_COORDINATOR_SELECTED_ACTION = "SET_DEPARTMENTAL_COORDINATOR_SELECTED_ACTION";
export const SET_IIA_DEPARTMENT_SELECTED_ACTION = "SET_IIA_DEPARTMENT_SELECTED_ACTION";
export const SET_IS_MODAL_OPEN_ACTION = "SET_IS_MODAL_OPEN";
export const SET_SORT_SELECTED_ACTION = "SET_SORT_SELECTED_ACTION";

export const reducer = (state, action) => {
    return {
        ...state,
        ...action.payload,
    }
}
